import {createStyles} from '@material-ui/core/styles';
import type {Theme} from '@material-ui/core/styles';

export default createStyles((theme: Theme) => ({
    root: {
        height: '17.778vh', //  Calc ViewPort Units: 160/900*100
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        padding: theme.spacing(6, 34, 20),
        minHeight: theme.spacing(40),
    },
    box: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        padding: theme.spacing(6, 34, 20),
        minHeight: theme.spacing(40),
    },
}));
